import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { MdArrowBackIosNew } from "react-icons/md";
import { useParams } from "react-router-dom";
import { PollApiCalls } from "../../apis/PollApiCalls";
import { Spin } from "../../components/standardization/YuJaLoading";
import { usePPTWebView } from "../../hooks/usePPTWebView";

import {
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    QUESTION_TYPES
} from "../../utils/constants";
import styles from "./PPTPollDetailPage.module.css";
import {LatexInline} from "../../components/Tiptap/latexParser";
import {questionCodeToSVG} from "../../utils/questionUtils";
import { useTranslation } from "react-i18next";

export default function PPTPollDetailPage() {
    const { t } = useTranslation();
    const { pollKey, pollCode } = useParams();
    const {goPollsPage} = usePPTWebView();
    const {getPublishedPollDataFromKey, getPollDataFromKey} = PollApiCalls();
    const [dataReady, setDataReady] = useState(false);
    const [poll, setPoll] = useState({});
    const [questions, setQuestions] = useState([]);


    useEffect(() => {
        if (pollCode) {
            getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
                setQuestions(res.questions);
                setPoll(res.poll);
            }).finally(() => {
                setDataReady(true);
            });
        } else {
            getPollDataFromKey(pollKey).then(res => {
                if (res && Object.entries(res).length > 0) {
                    const {questions=[]} = res;
                    setPoll(res);
                    setQuestions(questions);
                }
            }).finally(() => {
                setDataReady(true);
            });
        }

    }, []);

    return (
        <div className={styles.tableParentContainer}>

            <div className={styles.goBackLink} onClick={() => goPollsPage()}>
                <MdArrowBackIosNew/> {t("poll.pptCompletePageGoBackButtonText")}
            </div>
            <div style={{height: 20}}/>
            <div className={styles.controllerContainer}>
                <span className={styles.title}>{t("integration.pptPollTitleLabel")} {poll.pollTitle ? poll.pollTitle : ""}</span>
            </div>
            <div style={{height: 30}}/>

            <Table style={{backgroundColor: "#f6f4fa"}}>
                <thead style={{backgroundColor: "#f6f4fa"}}>
                <tr style={{backgroundColor: "#f6f4fa"}}>
                    <th width={100} >{t("accessibility.questionLabel")} #</th>
                    <th style={{textAlign: "start"}}>{t("accessibility.questionTitleLabel")}</th>
                </tr>
                </thead>
            </Table>


            <div className={styles.normalContainer} style={{position: "relative",}}>
                <div style={{position: "absolute", width: '100%', height: "100%", overflowY: "scroll"}}>
                    <Table >
                        <tbody>
                        {questions.map((item, index) => (
                            <tr key={index}>
                                <td width={100} >{item.serialNo}</td>
                                <td style={{textAlign: "start"}}>
                                    <span style={{display: "flex", alignItems: "center", gap: 20}}>
                                        {questionCodeToSVG(item.questionType, false, 20)}
                                        <span style={{flex: 1}}>
                                            {item.questionType === QUESTION_TYPES.FITB.name
                                                ? item.queTitle.replace(item.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX, "___")
                                                : <LatexInline>{item.queTitle}</LatexInline>
                                            }
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>



                {!dataReady &&
                    <div className={styles.animationContainer}>
                        <div style={{flex: 1}}/>
                        <Spin size="large" wrapperClassName="globalSpin" spinning={true} tip="Loading..."/>
                        <div style={{flex: 3}}/>
                    </div>
                }
            </div>
        </div>
    );
}